import React from 'react';

/**
 * A sleek, self-contained "AI Touch" loader animation for React TSX projects.
 * It features a central pulsating circle with radiating ripples.
 *
 * @returns {JSX.Element} The loader component.
 */
const AiTouchLoader = () => {
  return (
   <div className="w-full sm:w-[80%] md:w-[60%] min-h-[300px] sm:min-h-[400px] md:min-h-[500px] lg:min-h-[650px] py-8 mt-20 mb-12 flex flex-col items-center justify-center border border-gray-300 rounded-3xl mx-auto">
      <div className="ai-loader">
        <div className="ai-loader__ripple ai-loader__ripple--1"></div>
        <div className="ai-loader__ripple ai-loader__ripple--2"></div>
        <div className="ai-loader__ripple ai-loader__ripple--3"></div>
        <div className="ai-loader__core"></div>
      </div>
      <p className='font-semibold text-[18px] mt-4'>Processing image...</p>
    </div>
  );
};

export default AiTouchLoader;